'use strict';
import Vue from 'vue';

import store from './store/paymentSettings';
import ClientApp from './components/paymentSettings/Client';
import PublicApp from './components/paymentSettings/Public';

if(document.getElementById('paymentSettingsClient')) {
	new Vue({
	    name: 'ClientApp',
	    el: '#paymentSettingsClient',
	    template: '	<ClientApp />',
	    store,
	    components: {
	    	ClientApp
	    }
	});
}

if(document.getElementById('paymentSettingsPublic')) {
	new Vue({
	    name: 'PublicApp',
	    el: '#paymentSettingsPublic',
	    template: '	<PublicApp />',
	    store,
	    components: {
	    	PublicApp
	    }
	});
}

